import _ from "lodash";

export function formDownload(url, param) {
  let kyes = Object.keys(param);
  let paramArr = kyes.map(item => {
    return {
      name: item,
      value: _.isNil(param[item]) ? "" : param[item] // 剔除null  undefined 等无效字段
    };
  });
  paramArr.push({
    name: "AUTH-TOKEN",
    value: localStorage.getItem("AuthToken")
  });
  console.log(paramArr);
  var form = document.createElement("form");
  document.getElementsByTagName("body")[0].appendChild(form);
  form.setAttribute("style", "display:none");
  form.setAttribute("target", "_blank");
  form.setAttribute("method", "post");
  form.setAttribute("action", url);
  paramArr.forEach(item => {
    var input1 = document.createElement("input");
    input1.setAttribute("type", "hidden");
    input1.setAttribute("name", item.name);
    input1.setAttribute("value", item.value);
    form.appendChild(input1);
  });
  form.submit();
  form.remove();
}




export function downloadFile(data, name?) {
  // 假设 data 是返回来的二进制数据
  // const data = res.data
  const url = window.URL.createObjectURL(new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  if (name) {
    link.setAttribute('download', name)
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

}

export function downloadFileByLink(url) {
  if (!url) return;
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

}

